/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */
import { CURRENT_CLIENT_TEMPLATE_VAR } from '@core';
import { HttpClient } from '@angular/common/http';

import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import type {
  PowerConsumptionControllerV1GetFiltersV1PathParameters,
  PowerConsumptionControllerV1GetPowerConsumptionReportV1Params,
  PowerConsumptionControllerV1GetPowerConsumptionReportV1PathParameters,
  PowerConsumptionControllerV1GetPowerConsumptionV1Params,
  PowerConsumptionControllerV1GetPowerConsumptionV1PathParameters,
} from '../models';

@Injectable({ providedIn: 'root' })
export class PowerConsumptionService {
  private readonly http = inject(HttpClient);
  /**
   * Retrieves available filters for power consumption data.
   * @deprecated
   * @summary Get list of available filters
   */

  getFilters<TData = void>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
  }: PowerConsumptionControllerV1GetFiltersV1PathParameters): Observable<TData> {
    return this.http.get<TData>(`/devices/v1/clients/${clientId}/power-consumption/filters`);
  }
  /**
   * Retrieves a list of devices for a client with power consumption data.
   * @deprecated
   * @summary Get list of devices with power consumption data
   */

  getPowerConsumption<TData = void>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR }: PowerConsumptionControllerV1GetPowerConsumptionV1PathParameters,
    params?: PowerConsumptionControllerV1GetPowerConsumptionV1Params,
  ): Observable<TData> {
    return this.http.get<TData>(`/devices/v1/clients/${clientId}/power-consumption`, {
      params: (() => {
        const objectParamStrategies: Readonly<Record<string, 'flatten' | 'comma' | 'deepObject'>> = { filters: 'flatten' };

        const filteredParams: Record<string, string | number | boolean | Array<string | number | boolean>> = {};
        for (const [key, value] of Object.entries(params ?? {})) {
          if (
            value != null &&
            typeof value === 'object' &&
            !Array.isArray(value) &&
            Object.prototype.hasOwnProperty.call(objectParamStrategies, key)
          ) {
            const objectStrategy = objectParamStrategies[key];
            const entries = Object.entries(value as Record<string, unknown>);
            if (objectStrategy === 'comma') {
              const commaParts: string[] = [];
              for (const [prop, propValue] of entries) {
                if (Array.isArray(propValue)) {
                  const filteredItems = propValue.filter(
                    item => item != null && (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean'),
                  ) as Array<string | number | boolean>;
                  if (filteredItems.length) {
                    commaParts.push(prop, ...filteredItems.map(String));
                  }
                } else if (
                  propValue != null &&
                  (typeof propValue === 'string' || typeof propValue === 'number' || typeof propValue === 'boolean')
                ) {
                  commaParts.push(prop, String(propValue));
                }
              }
              if (commaParts.length) {
                filteredParams[key] = commaParts.join(',');
              }
            } else {
              for (const [prop, propValue] of entries) {
                const targetKey = objectStrategy === 'deepObject' ? key + '[' + prop + ']' : prop;
                if (Array.isArray(propValue)) {
                  const filteredProp = propValue.filter(
                    item => item != null && (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean'),
                  ) as Array<string | number | boolean>;
                  if (filteredProp.length) {
                    filteredParams[targetKey] = filteredProp;
                  }
                } else if (
                  propValue != null &&
                  (typeof propValue === 'string' || typeof propValue === 'number' || typeof propValue === 'boolean')
                ) {
                  filteredParams[targetKey] = propValue;
                }
              }
            }
            continue;
          }
          if (Array.isArray(value)) {
            const filtered = value.filter(
              item => item != null && (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean'),
            ) as Array<string | number | boolean>;
            if (filtered.length) {
              filteredParams[key] = filtered;
            }
          } else if (value != null && (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean')) {
            filteredParams[key] = value;
          }
        }
        return filteredParams;
      })(),
    });
  }
  /**
   * Retrieves all power consumption data for a client and returns it as a JSON file.
   * @deprecated
   * @summary Generate and download power consumption report
   */

  getPowerConsumptionReport<TData = void>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR }: PowerConsumptionControllerV1GetPowerConsumptionReportV1PathParameters,
    params?: PowerConsumptionControllerV1GetPowerConsumptionReportV1Params,
  ): Observable<TData> {
    return this.http.get<TData>(`/devices/v1/clients/${clientId}/power-consumption/report`, {
      params: (() => {
        const objectParamStrategies: Readonly<Record<string, 'flatten' | 'comma' | 'deepObject'>> = { filters: 'flatten' };

        const filteredParams: Record<string, string | number | boolean | Array<string | number | boolean>> = {};
        for (const [key, value] of Object.entries(params ?? {})) {
          if (
            value != null &&
            typeof value === 'object' &&
            !Array.isArray(value) &&
            Object.prototype.hasOwnProperty.call(objectParamStrategies, key)
          ) {
            const objectStrategy = objectParamStrategies[key];
            const entries = Object.entries(value as Record<string, unknown>);
            if (objectStrategy === 'comma') {
              const commaParts: string[] = [];
              for (const [prop, propValue] of entries) {
                if (Array.isArray(propValue)) {
                  const filteredItems = propValue.filter(
                    item => item != null && (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean'),
                  ) as Array<string | number | boolean>;
                  if (filteredItems.length) {
                    commaParts.push(prop, ...filteredItems.map(String));
                  }
                } else if (
                  propValue != null &&
                  (typeof propValue === 'string' || typeof propValue === 'number' || typeof propValue === 'boolean')
                ) {
                  commaParts.push(prop, String(propValue));
                }
              }
              if (commaParts.length) {
                filteredParams[key] = commaParts.join(',');
              }
            } else {
              for (const [prop, propValue] of entries) {
                const targetKey = objectStrategy === 'deepObject' ? key + '[' + prop + ']' : prop;
                if (Array.isArray(propValue)) {
                  const filteredProp = propValue.filter(
                    item => item != null && (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean'),
                  ) as Array<string | number | boolean>;
                  if (filteredProp.length) {
                    filteredParams[targetKey] = filteredProp;
                  }
                } else if (
                  propValue != null &&
                  (typeof propValue === 'string' || typeof propValue === 'number' || typeof propValue === 'boolean')
                ) {
                  filteredParams[targetKey] = propValue;
                }
              }
            }
            continue;
          }
          if (Array.isArray(value)) {
            const filtered = value.filter(
              item => item != null && (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean'),
            ) as Array<string | number | boolean>;
            if (filtered.length) {
              filteredParams[key] = filtered;
            }
          } else if (value != null && (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean')) {
            filteredParams[key] = value;
          }
        }
        return filteredParams;
      })(),
    });
  }
}
